import { api as generatedApi } from './generated';

export * from './generated';

// More info for invalidation rules at:
// - https://redux-toolkit.js.org/rtk-query/usage/automated-refetching
// - https://redux-toolkit.js.org/rtk-query/usage/manual-cache-updates
export const api = generatedApi.enhanceEndpoints({
  addTagTypes: ['Images'],
  endpoints: {},
});
